module.exports = __webpack_public_path__ + "img/C1.07e80bcb.svg";